import React, { Component } from "react";
import Icons from "../../../icon";

export class RequestProcess extends Component {
    constructor(props) {
        super(props);
    }

    renderMilestoneConnector = (id) => {
        let cssName;
        switch (id) {
            case 0:
                cssName = "horizontal-first-line"
                break;
            case 1:
                cssName = "horizontal-second-line"
                break;
            case 2:
                cssName = "horizontal-third-line"
                break;
            case 3:
                cssName = "horizontal-fourth-line"
                break;
            default:
        }
        return cssName;
    }

    renderMilestone = (data) => {
        if (data === undefined || data === null)
            return;

        return Object.values(data).map((o,index) => {
            return (
                <div key={o.MilestoneID}>
                    <Icons
                        key={o.MilestoneID}
                        customClassName={o.IsCancelled ? "circle-times-white" : o.IsCompleted ? "check-circle-solid" : "circle-solid"}
                        name={o.IsCancelled ? "circle-times-white" : o.IsCompleted ? "check-circle-solid" : "circle-solid"}
                        labelValue={o.MilestoneName}
                        size="32px"
                        containerClass={`icon-container ${!o.IsCompleted? "icon-container-ongoing-status" : null }`}
                    />
                    {index < data.length ? <div className={this.renderMilestoneConnector(index)}></div> : null}
                </div>
            );
        });
    };
    render() {
        const { data } = this.props;
        return (
            <div className={data.length > 4 ? "order-request-process-tab-2":"order-request-process-tab"}>
                {this.renderMilestone(data)}
            </div>
        );
    }
}